import { render, staticRenderFns } from "./SearchResultsDropdown.vue?vue&type=template&id=5ee64022&scoped=true"
import script from "./SearchResultsDropdown.vue?vue&type=script&lang=ts"
export * from "./SearchResultsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./SearchResultsDropdown.vue?vue&type=style&index=0&id=5ee64022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee64022",
  null
  
)

export default component.exports